/*
 * Product-card variant swatch hover.
 * Hovering a colour swatch swaps the card's main image to that variant's image;
 * leaving the swatch row restores the original. Delegated on document so it
 * covers every card context — collection grids, homepage rails, search,
 * quick-view — including cards inserted after load. Each swatch that has a
 * variant image carries data-swatch-media="<image url>" (see
 * snippets/bitco-product-card.liquid). Clicking a swatch still navigates to the
 * variant; this only affects the preview image on hover.
 */
(function () {
  var IMG = '.bitco-product-card__image';
  var SWATCH = '[data-swatch-media]';
  var ROW = '.bitco-product-card__swatches';

  function mainImage(fromEl) {
    var card = fromEl.closest('.bitco-product-card');
    return card ? card.querySelector(IMG) : null;
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest(SWATCH);
    if (!swatch) return;
    var img = mainImage(swatch);
    if (!img) return;
    var url = swatch.getAttribute('data-swatch-media');
    if (!url) return;
    // Remember the original image once, so we can restore it on leave.
    if (!('cardSwatchSrc' in img.dataset)) {
      img.dataset.cardSwatchSrc = img.getAttribute('src') || '';
      img.dataset.cardSwatchSrcset = img.getAttribute('srcset') || '';
    }
    if (img.getAttribute('src') !== url) {
      // Single-candidate srcset keeps the swapped image consistent with src
      // (avoids the browser re-selecting an original srcset candidate via sizes).
      img.setAttribute('srcset', url);
      img.setAttribute('src', url);
    }
  });

  document.addEventListener('mouseout', function (e) {
    var row = e.target.closest && e.target.closest(ROW);
    if (!row) return;
    // Still moving between swatches inside the same row — don't restore yet.
    if (e.relatedTarget && row.contains(e.relatedTarget)) return;
    var img = mainImage(row);
    if (!img || !('cardSwatchSrc' in img.dataset)) return;
    if (img.dataset.cardSwatchSrcset) {
      img.setAttribute('srcset', img.dataset.cardSwatchSrcset);
    } else {
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', img.dataset.cardSwatchSrc);
  });

  // Toggle a --scroll modifier on swatch strips that actually overflow, so the
  // CSS right-edge fade (a "scroll for more colours" cue) only shows when there
  // are more swatches than fit within the card.
  function markScrollable() {
    var strips = document.querySelectorAll('.bitco-product-card__swatches');
    for (var i = 0; i < strips.length; i++) {
      var el = strips[i];
      el.classList.toggle('bitco-product-card__swatches--scroll', el.scrollWidth - el.clientWidth > 1);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markScrollable);
  } else {
    markScrollable();
  }
  window.addEventListener('load', markScrollable);
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(markScrollable, 150);
  });
})();
